import type {
  DiscoveryV2ListParametersType,
  DiscoveryV2ListResponseType,
} from "@sellar-io/api-v2/types";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2InfiniteQueryOptions,
  apiV2Request,
  getDefaultInfiniteQueryOptions,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useDiscoveryV2ProductList = <TData = DiscoveryV2ListResponseType,>(
  params: DiscoveryV2ListParametersType,
  options?: ApiV2InfiniteQueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useInfiniteQuery({
    queryKey: [
      user?.uid,
      business?.id,
      ServerStateKeys.DiscoveryProducts,
      params,
    ],
    queryFn: ({ pageParam, signal }) =>
      apiV2Request({
        user,
        business,
        signal,
        method: "get",
        path: `discovery/v2/products`,
        params: {
          ...params,
          offset: pageParam,
        },
      }).then((data) => apiV2AssertResponse<TData>(data).data),
    ...getDefaultInfiniteQueryOptions({ ...options, limit: params.limit }),
  });
};
